import { render } from "./VisionMission.vue?vue&type=template&id=db63fd04"
import script from "./VisionMission.vue?vue&type=script&lang=js"
export * from "./VisionMission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__